import { render, staticRenderFns } from "./ReservationDeletedPlan.vue?vue&type=template&id=18a65b8a"
import script from "./ReservationDeletedPlan.vue?vue&type=script&lang=js"
export * from "./ReservationDeletedPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports